import { render, staticRenderFns } from "./unregisteredDetailsPieChart.vue?vue&type=template&id=c3b83a92&scoped=true"
import script from "./unregisteredDetailsPieChart.vue?vue&type=script&lang=js"
export * from "./unregisteredDetailsPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b83a92",
  null
  
)

export default component.exports